import { useState } from "react";
import { useTool, Honeypot, Field, SubmitButton, CopyButton, AiLabel, ToolError, SoftCta, Remaining } from "@/components/tools/ToolBits";

const OPTIONAL = [["style", "Style", "e.g. boho, minimalist"], ["material", "Material", "e.g. soy wax, sterling silver"],
  ["recipient", "Recipient", "e.g. mom, teacher"], ["occasion", "Occasion", "e.g. Mother's Day"]];

export const TagGenerator = () => {
  const [f, setF] = useState({ description: "", style: "", material: "", recipient: "", occasion: "" });
  const [state, run, trap] = useTool("/tools/tag-generator");
  const tags = state.data?.tags || [];
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div data-testid="tag-generator">
      <form onSubmit={(e) => { e.preventDefault(); run(f); }} className="relative space-y-5">
        <Honeypot trap={trap} />
        <Field id="tag-gen-description" label="Describe your product" textarea required minLength={3} maxLength={600}
          value={f.description} onChange={set("description")} placeholder="Hand-poured lavender soy candle in an amber glass jar, 8 oz" />
        <div className="grid gap-4 sm:grid-cols-2">
          {OPTIONAL.map(([k, l, ph]) => <Field key={k} id={`tag-gen-${k}`} label={l} hint="optional" maxLength={80} value={f[k]} onChange={set(k)} placeholder={ph} />)}
        </div>
        <SubmitButton busy={state.busy} label="Generate 13 tags" testid="tag-gen-submit" />
      </form>
      <ToolError state={state} />
      {tags.length > 0 && (
        <div data-testid="tag-gen-results" className="mt-8 rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-6">
          <div className="flex flex-wrap items-center justify-between gap-3"><AiLabel /><CopyButton text={tags.join(", ")} testid="tag-gen-copy-all" label="Copy all" /></div>
          <ul className="mt-5 flex flex-wrap gap-2" aria-label="13 suggested tags">
            {tags.map((t, i) => (
              <li key={t} data-testid={`tag-gen-tag-${i}`} className="flex items-center gap-2 rounded-full border border-[#5EE6D0]/25 bg-[#5EE6D0]/[0.06] py-1 pl-3 pr-1">
                <span className="font-mono text-[13px] text-foreground">{t}</span><span className="text-[11px] text-muted-foreground">{t.length}</span>
                <CopyButton text={t} testid={`tag-gen-copy-${i}`} />
              </li>
            ))}
          </ul>
          <p className="mt-4 text-xs text-muted-foreground">{tags.length} tags · each 20 characters or fewer · no duplicates</p>
          <Remaining data={state.data} />
        </div>
      )}
      {tags.length > 0 && <SoftCta />}
    </div>
  );
};
